export const loadUserFeed = (payload) => {
    const { userId, clientId, next, apiVersion } = payload || {};
    return {
        type: 'OLY_ENGINE_STORE_LOAD_USER_FEED',
        payload: { userId, clientId, next, apiVersion },
    };
};
export const loadUserFeedSuccess = (userFeed) => ({
    type: 'OLY_ENGINE_STORE_LOAD_USER_FEED_SUCCESS',
    payload: { userFeed },
});
export const loadUserFeedError = (error) => ({
    type: 'OLY_ENGINE_STORE_LOAD_USER_FEED_ERRROR',
    payload: { error },
});
export const resetUserFeed = () => ({
    type: 'OLY_ENGINE_STORE_RESET_USER_FEED',
});
export default {
    loadUserFeed,
    loadUserFeedSuccess,
    loadUserFeedError,
    resetUserFeed,
};
